import LanguageHelper from './models/LanguageHelper';

export default { languages: LanguageHelper };
